export const titleCaseToSentenceCase = (input: string): string => {
  return (
    input
      .match(/[A-Z][a-z]+|[0-9]+/g)
      ?.map((v, i) => {
        if (i !== 0) {
          return v.toLowerCase();
        }
        return v;
      })
      .join(" ") ?? ""
  );
};
